import { RocheUIDropdown, RocheUIDropdownItems } from '@repo/roche-ui';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import React, { FC, useState } from 'react';
import { useTranslation } from '../../hooks/use-translation';
import { StringService } from '../../services/string';

type RocheDropdownProps = BlokToComponentProps<{
  label: string;
  tooltip?: string;
  options: RocheUIDropdownItems;
  required?: boolean;
  placeholder?: string;
  selected?: number;
}>;

export const RocheDropdown: FC<RocheDropdownProps> = ({ blok }): JSX.Element => {
  const { label, tooltip, options, required = false, placeholder, selected } = blok;
  const optionalLabel = useTranslation('optional');
  const selectLabel = useTranslation('please select');
  const componentId = `roche-dropdown-${label.toLowerCase().replace(/\s+/g, '-')}-${StringService.generate(9)}`;
  const componentName = componentId;

  const initialValue =
    selected !== undefined && selected >= 0 && selected < options.length && options[selected]
      ? options[selected].value
      : '';

  const [value, setValue] = useState<string>(initialValue);
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const handleChange = (newValue: string): void => {
    setValue(newValue);
    setIsDirty(true);
  };

  const handleBlur = (): void => {
    setIsDirty(true);
  };

  const isValid = required ? !!value : true;
  const hasValidationError = isDirty && !isValid;

  const displayLabel = required ? label : `${label} ${optionalLabel}`;
  const errorMessage = hasValidationError ? `${selectLabel} ${label}` : '';

  return (
    <RocheUIDropdown
      id={componentId}
      name={componentName}
      label={displayLabel}
      tooltip={tooltip}
      options={options}
      value={value}
      placeholder={placeholder ? placeholder : selectLabel}
      error={errorMessage}
      hasError={hasValidationError}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
